module.exports = __webpack_public_path__ + "static/rules-illiustration-b84994d4abf1c46f3f2f4306d00f4e84.jpg";